<admin-app-header></admin-app-header>
<main class="insights-page">
    <div class="container-fluid px-4">
        <div class="insights-hero">
            <div>
                <span class="eyebrow">Data quality</span>
                <h1>Building allocations</h1>
                <p>Confirm each building's city, suburb and category before it contributes to suburb pricing. This view covers all enterprises.</p>
            </div>
            <button type="button" class="btn btn-primary" (click)="refresh()" [disabled]="refreshing || loading || saving.size > 0">{{ refreshing ? 'Refreshing…' : 'Refresh insights' }}</button>
        </div>
        <nav class="insight-tabs" aria-label="Insights administration">
            <a routerLink="/admin/market-insights">Market analysis</a><a routerLink="/admin/building-allocations" aria-current="page">Building allocations</a
            ><a routerLink="/market-insights">Public dashboard</a>
        </nav>
        <div *ngIf="error" class="alert alert-danger" role="alert">{{ error }} <button type="button" *ngIf="!rows.length" class="btn btn-sm btn-outline-dark" (click)="load()">Retry</button></div>
        <div *ngIf="message" class="alert alert-success" role="status">{{ message }}</div>
        <div class="insight-toolbar">
            <label>Find a building<input type="search" class="form-control" [(ngModel)]="search" placeholder="Building, landlord, city or suburb" /></label
            ><label
                >Allocation status<select class="form-select" [(ngModel)]="status">
                    <option value="pending">Needs confirmation</option>
                    <option value="confirmed">Confirmed</option>
                    <option value="all">All buildings</option>
                </select></label
            ><span class="small text-muted">{{ filtered.length }} buildings</span>
        </div>
        <p *ngIf="loading" class="insight-notice" role="status">Loading buildings…</p>
        <section class="insight-card" *ngIf="!loading">
            <div class="table-responsive">
                <table class="table insight-table">
                    <thead>
                        <tr>
                            <th>Building</th>
                            <th>Source location</th>
                            <th>City</th>
                            <th>Suburb</th>
                            <th>Category</th>
                            <th>Confirmed</th>
                            <th>Exclude</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of filtered">
                            <th scope="row">
                                {{ row.title }}<small>{{ row.merchantName }} · {{ row.enterpriseKey }} · {{ row.status }}</small>
                            </th>
                            <td>
                                {{ row.sourceSuburb }}<small class="d-block">{{ row.sourceCity }}</small>
                            </td>
                            <td><input class="form-control form-control-sm allocation-input" [(ngModel)]="row.city" [attr.aria-label]="'City for ' + row.title" maxlength="100" /></td>
                            <td><input class="form-control form-control-sm allocation-input" [(ngModel)]="row.suburb" [attr.aria-label]="'Suburb for ' + row.title" maxlength="100" /></td>
                            <td>
                                <input
                                    class="form-control form-control-sm allocation-input"
                                    [(ngModel)]="row.category"
                                    [attr.aria-label]="'Category for ' + row.title"
                                    maxlength="100"
                                    list="allocation-categories"
                                />
                            </td>
                            <td><input type="checkbox" class="form-check-input" [(ngModel)]="row.confirmed" [attr.aria-label]="'Confirm allocation for ' + row.title" /></td>
                            <td><input type="checkbox" class="form-check-input" [(ngModel)]="row.excluded" [attr.aria-label]="'Exclude ' + row.title + ' from market benchmarks'" /></td>
                            <td>
                                <button
                                    type="button"
                                    class="btn btn-sm btn-outline-primary"
                                    (click)="save(row)"
                                    [disabled]="saving.has(row.parkingKey) || refreshing || !row.city.trim() || !row.suburb.trim()"
                                >
                                    {{ saving.has(row.parkingKey) ? 'Saving…' : 'Save' }}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <datalist id="allocation-categories">
                <option value="General"></option>
                <option value="Covered"></option>
                <option value="Basement"></option>
                <option value="Open"></option>
            </datalist>
            <p *ngIf="!filtered.length" class="text-muted">No buildings match this filter.</p>
            <p class="small text-muted mb-0">
                Save each row before refreshing. Allocations affect reporting only; listing addresses remain unchanged. Unconfirmed buildings are omitted from suburb benchmarks. Only published ParkUpp
                monthly listings contribute to public market prices.
            </p>
        </section>
    </div>
</main>
